// Simple request queue to prevent too many concurrent API calls
class RequestQueue {
  constructor() {
    this.queue = [];
    this.processing = false;
    this.maxConcurrent = 3; // Maximum 3 concurrent requests
    this.activeRequests = 0;
  }

  async add(requestFn) {
    return new Promise((resolve, reject) => {
      this.queue.push({
        requestFn,
        resolve,
        reject
      });
      this.process();
    });
  }

  async process() {
    if (this.processing || this.activeRequests >= this.maxConcurrent) {
      return;
    }

    this.processing = true;

    while (this.queue.length > 0 && this.activeRequests < this.maxConcurrent) {
      const { requestFn, resolve, reject } = this.queue.shift();
      this.activeRequests++;

      try {
        const result = await requestFn();
        resolve(result);
      } catch (error) {
        reject(error);
      } finally {
        this.activeRequests--;
      }
    }

    this.processing = false;

    // Continue processing if there are more requests
    if (this.queue.length > 0) {
      setTimeout(() => this.process(), 100); // Small delay between batches
    }
  }
}

// Create a singleton instance
const requestQueue = new RequestQueue();

export default requestQueue;
